import type { ReactNode } from 'react';
import { Mail, Phone } from 'lucide-react';

export function CrmHeader({ title, description, children }: { title: string; description: string; children: ReactNode }) {
  return <div className="flex flex-wrap items-center justify-between gap-4">
    <div><h1 className="text-2xl font-bold text-gray-900">{title}</h1><p className="text-gray-600">{description}</p></div>
    <div className="flex flex-wrap items-center gap-3">{children}</div>
  </div>;
}

export function CrmPagination({ pagination, label, onPage }: {
  pagination?: { page: number; pages: number; total: number }; label: string; onPage: (page: number) => void;
}) {
  if (!pagination) return null;
  const { page, pages, total } = pagination;
  return <div className="flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 px-4 py-3">
    <p className="text-sm text-gray-700">{total} {label}{total > 0 && ` · Pagina ${page} di ${Math.max(1, pages)}`}</p>
    {pages > 1 && <div className="flex gap-2">
      <button onClick={() => onPage(page - 1)} disabled={page <= 1} className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50">Precedente</button>
      <button onClick={() => onPage(page + 1)} disabled={page >= pages} className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50">Successivo</button>
    </div>}
  </div>;
}

export function CrmContacts({ email, telefono }: { email?: string | null; telefono?: string | null }) {
  return <div className="text-sm text-gray-900 space-y-1">
    {email && <a href={`mailto:${email}`} onClick={e => e.stopPropagation()} className="flex items-center gap-1 hover:underline"><Mail className="h-4 w-4 text-gray-400" />{email}</a>}
    {telefono && <a href={`tel:${telefono}`} onClick={e => e.stopPropagation()} className="flex items-center gap-1 hover:underline"><Phone className="h-4 w-4 text-gray-400" />{telefono}</a>}
    {!email && !telefono && <span className="text-gray-400">—</span>}
  </div>;
}

export function CrmTabs<T extends string>({ tabs, active, onChange }: {
  tabs: { key: T; label: string }[]; active: T; onChange: (key: T) => void;
}) {
  return <div className="border-b border-gray-200 overflow-x-auto"><nav aria-label="Sezioni scheda" className="flex gap-8">
    {tabs.map(tab => <button key={tab.key} aria-current={active === tab.key ? 'page' : undefined} onClick={() => onChange(tab.key)} className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm ${active === tab.key ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>{tab.label}</button>)}
  </nav></div>;
}
